module.exports = __webpack_public_path__ + "static/media/event-07.09ef4fdd.jpg";